export const appModules = [
  {
    name: 'Home',
    pathname: '/dashboard',
    route: '/dashboard',
    icon: 'https://res.cloudinary.com/dgny8sjrg/image/upload/v1638787005/Bizedge_Frontend_Assets/Home_Icon_xqq0xn.svg'
  },
  {
    name: 'People',
    pathname: '/hr?type=all-employees&tab=all-employee-home',
    route: '/hr',
    icon: 'https://bizedge-prod.s3.us-west-2.amazonaws.com/Group+4.svg'
  },
  {
    name: 'Payroll',
    pathname: '/payroll?tab=home',
    route: '/payroll',
    icon: 'https://bizedge-prod.s3.us-west-2.amazonaws.com/Group+16.svg',
    openInNewTab: true
  },
  {
    name: 'Attendance',
    pathname: '/time-and-attendance',
    route: '/time-and-attendance',
    icon: 'https://bizedge-prod.s3.us-west-2.amazonaws.com/Vector+(18).svg'
  },
  {
    name: 'Vehicles',
    pathname: '/fleet?tab=home',
    route: '/fleet',
    icon: 'https://bizedge-prod.s3.us-west-2.amazonaws.com/Vector+(19).svg'
  },
  {
    name: 'Assets',
    pathname: '/assets?tab=home',
    route: 'assets',
    icon: 'https://bizedge-prod.s3.us-west-2.amazonaws.com/LwwsIZ.tif.svg'
  }
];

// / import { useMediaQuery } from 'react-responsive';

// const NAV_PATH = {
//   access_payroll: '/payroll',
//   access_hr: '/hr',
//   access_accounting: '/accounts',
//   access_assets: '/assets',
//   access_vehicles: '/fleet',
//   access_directories: '/business-directory',
//   access_docgen: '/doc-gen'
// };
export const NAV = {
  access_payroll: '/payroll?tab=home',
  access_hr: '/hr?type=all-employees&tab=all-employee-home',
  access_accounting: '/accounts?tab=overview-home',
  access_assets: '/assets?tab=home',
  access_vehicles: '/fleet?tab=home',
  access_directories: '/business-directory',
  access_docgen: '/doc-gen?tab=home'
};

export const NAV_ICONS = {
  access_payroll: (
    <img
      src='https://bizedge-prod.s3.us-west-2.amazonaws.com/Group+16.svg'
      width={20}
      alt='icon'
    />
  ),
  access_hr: (
    <img
      src='https://bizedge-prod.s3.us-west-2.amazonaws.com/Group+4.svg'
      width={20}
      alt='icon'
    />
  ),
  // access_accounting: <img src={AccountingICON} width={20} alt='icon' />,
  access_assets: (
    <img
      src='https://bizedge-prod.s3.us-west-2.amazonaws.com/LwwsIZ.tif.svg'
      alt='icon'
      width={20}
    />
  ),
  access_vehicles: (
    <img
      src='https://bizedge-prod.s3.us-west-2.amazonaws.com/Vector+(19).svg'
      width={20}
      alt='icon'
    />
  ),
  access_directories: (
    <img
      src='https://res.cloudinary.com/dgny8sjrg/image/upload/v1638787225/Bizedge_Frontend_Assets/Business_Dir_icon_sq0djx.svg'
      width={20}
      alt='icon'
    />
  )
  // access_docgen: <img src={DocGenICON} width={20} alt='icon' />
};
